import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import App from "./app/js/App";
import { history } from "./store";
import LoginContainer from "./app/js/auth/LoginContainer";

const Root = ({ store }) => (
    <Provider store={store}>
        <Router history={history}>
            <CompatRouter>
                <Switch>
                    <Route path="/login" component={LoginContainer} />
                    <Route path="/:filter?" component={App} />
                </Switch>
            </CompatRouter>
        </Router>
    </Provider>
);

Root.propTypes = {
    store: PropTypes.object.isRequired,
};

export default Root;
